import { put, call } from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import debug from 'Helper/debugHelpers'
import { errorHandlers } from '../XtractAPI.jsx'
const maxFailCount = 6
/**
 * handles checking internet connection, incrementing
 * this.props.appConfig.API_FAIL_COUNT
 */
export default function* connectionFailure(count, error) {
  // check if browser is online
  if (!window.navigator.onLine) {
    debug.log('connectionFailure - network offline', debug.logLevels.API)
    yield call(errorHandlers.offlineErrorHandler)
    return false
  } else if (error?.message == "The user aborted a request.") {
    // we intentionally aborted this so don't treat it as an error.
    return false
  } else if (error != null && count < maxFailCount) {
    // if this was the result of an error return true so we retry
    yield delay(250)
    return true
  } else {
    if (count >= maxFailCount) {
      debug.log(
        'connectionFailure - max error count exceeded, calling maxCountErrorHandler',
        debug.logLevels.API
      )
      yield call(errorHandlers.maxCountErrorHandler, error)

      return false
    } else {
      debug.log(
        'connectionFailure - calling singleErrorHandler and scheduling retry.',
        debug.logLevels.API
      )
      // otherwise call action to increment the fail count
      yield put({
        type: 'SET_API_FAIL_COUNT',
        value: count + 1
      })
      yield call(errorHandlers.singleErrorHandler, count, error)
      // and return true to schedule retry
      return true
    }
  }
}
